/* beautiful-react-hooks version: 0.27.4 */
import useMouseEvents from './useMouseEvents.js';
import useMouseState from './useMouseState.js';

var useMouse = function useMouse() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var state = useMouseState(ref);
  var events = useMouseEvents(ref);
  return [state, events];
};

export default useMouse;